<mat-toolbar class="p-0 mat-elevation-z1">

  <div fxFlex fxFill fxLayout="row" fxLayoutAlign="start center">

    <div fxFlex="1 0 auto" fxLayout="row" fxLayoutAlign="start center">

      <button mat-icon-button class="navbar-toggle-button"
              *ngIf="!hiddenNavbar && !rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>

      <div class="toolbar-separator" *ngIf="!hiddenNavbar && !rightNavbar" fxHide.gt-md></div>

      <div fxLayout="row" fxLayoutAlign="start center" *ngIf="horizontalNavbar">
        <div class="logo ml-16">
          <img alt="logo" class="logo-icon" src="assets/images/logos/torch.png">
        </div>
      </div>

      <div class="px-8 px-md-16">
        <fuse-shortcuts [navigation]="navigation"></fuse-shortcuts>
      </div>

    </div>

    <div class="" fxFlex="0 1 auto" fxLayout="row" fxLayoutAlign="center center">

      <button mat-icon-button class="navbar-toggle-button"
              *ngIf="allNotifications && allNotifications.length > 0" [matMenuTriggerFor]="notificationsMenu">
        <mat-icon class="secondary-text" matBadge="{{allNotifications.length}}" matTooltip="TORCH Notifications"
                  matBadgeColor="warn">notifications_active
        </mat-icon>
      </button>

      <mat-menu #notificationsMenu="matMenu">
        <button mat-menu-item *ngFor="let notification of allNotifications" (click)="openDialog(notification)">
          <mat-icon [ngStyle]="{'color': notification|notificationColor}">{{ notification|notificationIcon }}</mat-icon>
          <span>{{notification.notificationTitle}}</span>
        </button>
      </mat-menu>

      <div class="toolbar-separator" *ngIf="allNotifications && allNotifications.length > 0"></div>

      <button mat-button [matMenuTriggerFor]="userMenu" class="user-button">

        <div fxLayout="row" fxLayoutAlign="center center">
          <ng-container *ngIf="currentUser|async as user; else loadingUserProfile">
            <div class="avatar mr-0 mr-sm-16">
              <ng-template #loadingAvatar>
                <mat-spinner diameter="20" color="accent"></mat-spinner>
              </ng-template>
              <img *ngIf="currentUserAvatar|async as avatar; else loadingAvatar" [src]="avatar|safe:'url'"
                   alt="User Profile Image">
            </div>
            <div class="user-information mr-12" fxLayout="column" fxLayoutAlign="center center">
              <span class="username" fxHide fxShow.gt-sm>{{user.displayName}}</span>
              <span class="title" fxHide fxShow.gt-sm>{{user.jobTitle}}</span>
            </div>
          </ng-container>
          <ng-template #loadingUserProfile>
            <mat-spinner class="user-profile-spinner" diameter="20"></mat-spinner>
          </ng-template>

        </div>
      </button>

      <mat-menu #userMenu="matMenu" class="toolbar-user-menu">
        <button mat-menu-item routerLink="/pages/user/profile">
          <mat-icon>person</mat-icon>
          <span>Profile</span>
        </button>

        <button mat-menu-item (click)="logout()">
          <mat-icon>exit_to_app</mat-icon>
          <span>Logout</span>
        </button>

        <button mat-menu-item (click)="openManageQueryFiltersDialog()"
                *ngxPermissionsOnly="['torchAdmin', 'torchGlobalAdmin']">
          <mat-icon>rule</mat-icon>
          <span>Query Filters</span>
        </button>

        <button mat-menu-item [matMenuTriggerFor]="updateMenu" *ngxPermissionsOnly="['torchAdmin', 'torchGlobalAdmin']">
          <mat-icon>upgrade</mat-icon>
          <span>PWA Updates</span>
        </button>
      </mat-menu>

      <mat-menu #updateMenu="matMenu" class="toolbar-update-menu">
        <button mat-menu-item (click)="checkSoftwareUpdate()">
          <mat-icon>update</mat-icon>
          <span>Check for Update</span>
        </button>
        <button mat-menu-item (click)="testSoftwareUpdateAlert()">
          <mat-icon>sync_alt</mat-icon>
          <span>Test User Prompt</span>
        </button>
      </mat-menu>

      <div class="toolbar-separator"></div>

      <!-- FDX STOCK SECTION -->

      <button mat-button class="stock-button" *ngIf="showStockPrice">
        <div fxLayout="row" fxLayoutAlign="center center" matTooltip="New York Stock Exchange: FDX">
          <ng-container *ngIf="stockPrice?.latestPrice; else loadingStockPrice">
            <mat-icon class="stock-icon mr-0 mr-sm-16">attach_money</mat-icon>
            <div class="user-information mr-12" fxLayout="column" fxLayoutAlign="center center">
              <span class="username" fxHide fxShow.gt-sm>{{ stockPrice?.latestPrice | currency }}</span>
              <span class="title" [ngStyle]="{'color': stockPrice?.changePercent > 0 ? 'limegreen' : 'tomato'}" fxHide
                    fxShow.gt-sm>{{stockPrice?.changePercent | percent:'1.2-2'}}</span>
            </div>
          </ng-container>
          <ng-template #loadingStockPrice>
            <mat-spinner class="stock-spinner" diameter="20" color="accent"></mat-spinner>
          </ng-template>
        </div>
      </button>

      <div class="toolbar-separator" *ngIf="showStockPrice"></div>

      <!-- FDX STOCK SECTION -->

      <ng-container *ngxPermissionsOnly="['stagingPermission', 'torchAdmin', 'torchGlobalAdmin']">
        <app-environment-button></app-environment-button>
      </ng-container>

      <div class="toolbar-separator"
           *ngxPermissionsOnly="['stagingPermission', 'torchAdmin', 'torchGlobalAdmin']"></div>

      <button mat-icon-button class="quick-panel-toggle-button" aria-label="Toggle darkMode" (click)="toggleDarkMode()">
        <mat-icon [@animate]="{value:'*',params:{delay:'60ms',scale:'0.2'}}" class="secondary-text"
                  *ngIf="isDarkMode(darkMode|async)" matTooltip="Disable Dark Mode">
          wb_sunny
        </mat-icon>
        <mat-icon [@animate]="{value:'*',params:{delay:'60ms',scale:'0.2'}}" class="secondary-text"
                  *ngIf="!isDarkMode(darkMode|async)" matTooltip="Enable Dark Mode">
          brightness_3
        </mat-icon>
      </button>

      <div class="toolbar-separator"></div>

      <button mat-icon-button class="quick-panel-toggle-button" aria-label="More Info"
              [matMenuTriggerFor]="moreInfoMenu">
        <mat-icon class="secondary-text">help</mat-icon>
      </button>

      <mat-menu #moreInfoMenu="matMenu" class="toolbar-user-menu">
        <button mat-menu-item (click)="openFeedbackDialog()" #submitFeedbackButton>
          <mat-icon>question_answer</mat-icon>
          <span>Submit Feedback</span>
        </button>

      </mat-menu>

      <div class="toolbar-separator"></div>

      <button mat-icon-button class="quick-panel-toggle-button" aria-label="Toggle fullscreen" toggleFullscreen>
        <mat-icon class="secondary-text" matTooltip="Toggle Fullscreen">zoom_out_map</mat-icon>
      </button>

      <div class="toolbar-separator"></div>

      <button mat-icon-button
              class="quick-panel-toggle-button"
              (click)="toggleSidebarOpen('quickPanel')"
              aria-label="Toggle quick panel">
        <mat-icon class="secondary-text" matTooltip="TORCH Options">format_list_bulleted</mat-icon>
      </button>

      <div class="toolbar-separator" *ngIf="!hiddenNavbar && rightNavbar" fxHide fxShow.gt-xs></div>

      <button mat-icon-button class="navbar-toggle-button"
              *ngIf="!hiddenNavbar && rightNavbar" (click)="toggleSidebarOpen('navbar')" fxHide.gt-md>
        <mat-icon class="secondary-text">menu</mat-icon>
      </button>

    </div>

  </div>

</mat-toolbar>
